module.exports = __webpack_public_path__ + "img/clue2.fe252228.png";